@let s = sections();
<div class="email-body">{{ s.body }}</div>
@if (s.signature) {
  <div class="email-signature">{{ s.signature }}</div>
}
@if (s.previous) {
  <button type="button" class="email-previous-toggle" [attr.aria-expanded]="showPrevious()" (click)="togglePrevious()">
    <svg class="email-previous-chevron" [class.is-open]="showPrevious()" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M9 5l7 7-7 7" stroke="currentColor" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <span>{{ (showPrevious() ? 'email_message.lbl_hide_previous' : 'email_message.lbl_show_previous') | translate }}</span>
  </button>
  @if (showPrevious()) {
    <div class="email-previous">{{ s.previous }}</div>
  }
}
